// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"c17125ac","341":"4bce6f19","377":"9c6de7de","438":"fb0cdf3e","706":"7f85aa87","996":"86fc04da"}[chunkId] + ".chunk.js";
};